var _defs, _g;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgMail = function SvgMail(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 29,
    viewBox: "0 0 44 29",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "email icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, desc === undefined ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, "email icon") : desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    filter: "url(#a)",
    transform: "translate(-395 -2832)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M436.743 2832h-39.487c-1.24 0-2.256 1.004-2.256 2.23v24.54c0 1.226 1.015 2.23 2.256 2.23h39.488c1.24 0 2.256-1.004 2.256-2.23v-24.54c0-1.226-1.015-2.23-2.257-2.23m-.846 1.673-17.599 13.05c-.316.238-.802.387-1.298.385-.496.002-.982-.147-1.298-.385l-17.599-13.05zm-9.401 13.911 9.59 11.712.031.031h-38.234q.016-.015.031-.031l9.59-11.712a.83.83 0 0 0-.126-1.177.85.85 0 0 0-1.19.124l-9.496 11.597v-23.41l17.995 13.343c.676.498 1.5.718 2.313.72.812-.002 1.636-.221 2.313-.72l17.994-13.342v23.41l-9.496-11.598a.85.85 0 0 0-1.19-.124.83.83 0 0 0-.125 1.177"
  }))));
};
export default SvgMail;